import merchSettingsReducer from "./merchSettingsSlice";

export default merchSettingsReducer;
